/* MATRIKAR — Préréglage du véhicule sur les pages produit par modèle.
 *
 * Contexte : les 100 fiches « {Marque} {Modèle} Floor Mats » portent le métachamp
 * custom.vehicle_fitment. La page SAIT donc de quel char il s'agit, alors que le
 * sélecteur redemandait tout depuis zéro (et laissait même choisir un autre véhicule,
 * ce qui produisait une commande incohérente avec le titre de la fiche).
 *
 * Ce script est ADDITIF : il n'modifie pas matrikar-vehicle-fit.js, il se contente
 * d'appeler son API publique (MKVFIT.pMake / pModel). Retirer les deux lignes du
 * snippet suffit à tout annuler.
 *
 * Règle : la page PROPOSE son véhicule, elle ne l'impose pas. Marque et modèle sont
 * pré-remplis pour épargner deux clics, mais restent librement modifiables : un client
 * qui roule autre chose doit pouvoir changer de véhicule sans quitter la page.
 *
 * 30 août 2026 : le verrouillage marque/modèle a été retiré. Il enfermait le client sur
 * la fiche, et sa seule sortie menait à la page de marque où 680 modèles sur 780 sont
 * des pastilles inertes. Cul-de-sac.
 *
 * 31 août 2026 : déverrouiller seul ne suffisait pas. Un client parti d'une fiche Audi A3
 * qui choisissait une Porsche Cayenne restait sur la fiche Audi, et le panier affichait
 * « Audi A3 Sportback » avec une garantie de compatibilité « Porsche Cayenne ». Commande
 * fausse. Désormais, changer de marque ou de modèle renvoie sur la fiche normale du même
 * coloris, celle qui ne porte aucun nom de véhicule. Le véhicule choisi reste enregistré.
 */
(function () {
  'use strict';

  var V = window.MK_PAGE_VEHICLE;
  if (!V || !V.make || !V.model) return;

  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var MAX_TRIES = 100;                 // 100 × 100 ms = 10 s, aligné sur waitForDB
  var tries = 0;

  function norm(s) { return (s == null ? '' : String(s)).trim().toLowerCase(); }
  function g(id) { return document.getElementById(id); }

  function savedVehicle() {
    try { return JSON.parse(localStorage.getItem('matrikar_vehicle') || 'null'); }
    catch (e) { return null; }
  }

  /* Le client vient de valider un vehicule dans le selecteur. Si ce n'est plus celui de
     la page, on quitte : cette fiche porte un nom de vehicule et ne peut pas rester
     affichee pour un autre char. On part vers la fiche normale du meme coloris.
     Aucune boucle possible : la fiche normale n'expose pas MK_PAGE_VEHICLE. */
  function onVehicleConfirmed(e) {
    var sel = e && e.detail;
    if (!sel || !sel.make || !sel.model) return;
    if (norm(sel.make) === norm(V.make) && norm(sel.model) === norm(V.model)) return;
    if (!V.genericUrl) return;
    window.location.assign(V.genericUrl);
  }
  document.addEventListener('matrikar:vehicleSelected', onVehicleConfirmed);

  function ready() {
    return window.MKVFIT
      && typeof window.MKVFIT.pMake === 'function'
      && typeof window.MKVFIT.pModel === 'function'
      && window.MATRIKAR_DB
      && g('mkvfit-btn-make')
      && g('mkvfit-btn-model');
  }

  /* Avis discret : on ne change jamais le véhicule enregistré en douce. */
  function notice(text) {
    if (g('mk-preset-note')) return;
    var wrap = g('mkvfit-wrap');
    if (!wrap) return;
    var el = document.createElement('div');
    el.id = 'mk-preset-note';
    el.setAttribute('role', 'status');
    el.style.cssText = 'margin:0 0 10px;padding:8px 12px;border-left:3px solid #D71A23;'
      + 'background:#FBF6F6;color:#030213;font-size:13px;line-height:1.4;border-radius:4px;';
    el.textContent = text;
    wrap.insertBefore(el, wrap.firstChild);
  }

  function apply() {
    var s = savedVehicle();
    var matches = s && norm(s.make) === norm(V.make) && norm(s.model) === norm(V.model);

    if (matches) { return; }   /* deja le bon vehicule enregistre : rien a faire */

    if (s && s.make) {
      /* Véhicule enregistré différent. La page fait autorité, sinon le client
         achèterait des tapis titrés « V.make V.model » pour un autre char. */
      notice(FR
        ? 'Véhicule réglé sur ' + V.make + ' ' + V.model + ' pour cette page.'
        : 'Vehicle set to ' + V.make + ' ' + V.model + ' for this page.');
      try { localStorage.removeItem('matrikar_vehicle'); } catch (e) {}
      try {
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'matrikar_vehicle', newValue: null, oldValue: 'x'
        }));
      } catch (e) {}
      var savedPanel = g('mkvfit-saved');
      var selPanel = g('mkvfit-selector');
      if (savedPanel) savedPanel.style.display = 'none';
      if (selPanel) selPanel.style.display = 'block';
    }

    window.MKVFIT.pMake(V.make);
    window.MKVFIT.pModel(V.model);
  }

  var timer = setInterval(function () {
    tries++;
    if (ready()) {
      clearInterval(timer);
      try { apply(); } catch (e) { /* jamais bloquer la page */ }
    } else if (tries > MAX_TRIES) {
      clearInterval(timer);   /* sélecteur normal, aucun préréglage */
    }
  }, 100);
})();
